import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react';

import { Breadcrumb } from '@app/components/home/Breadcrumb';
import { useHeadMeta } from '@app/hooks/useHeadMeta';
import { cn } from '@app/libs/utils';
import { infoService } from '@app/services/info.service';
import { withLayout } from '@components/withLayout';

export const getServerSideProps: GetServerSideProps = async ctx => {
  const { data, success, message, error } = await infoService
    .setServerContext(ctx.req, ctx.res)
    .setCookies(ctx.req.headers.cookie || '')
    .get('about');
  return {
    props: {
      data: data || null,
      success,
      message,
      error: error ?? null,
    },
  };
};

const AboutPage: React.FC = (props: any) => {
  const { data } = props;
  const { setTitle } = useHeadMeta();

  useEffect(() => {
    setTitle('Về chúng tôi');
  }, [setTitle]);

  return (
    <>
      <div className="bg-gray-200/80 -mb-15">
        <Breadcrumb
          items={[{ label: 'Giới thiệu', href: '/about' }]}
          className={cn('w-auto 2xl:w-[90rem] p-5 sm:px-6 text-gray-900 text-sm flex mx-auto')}
        />
      </div>
      <section className="w-full">
        <div className="2xl:w-[90rem] w-full mx-auto px-5 py-10">
          <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: data }} />
        </div>
      </section>
    </>
  );
};

export default withLayout(AboutPage);
